<template lang='pug'>
  i.svg-icon.svg-icon-attachFile
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')
      
      path(d="M48.01,94.07c-1.98-0.4-4.04-0.59-5.94-1.23c-10.67-3.59-17.09-10.96-19.14-22.05c-0.29-1.56-0.34-3.19-0.34-4.79 c-0.03-12.55-0.02-25.09-0.01-37.64c0-2.27,1.47-3.88,3.55-3.93c1.91-0.04,3.42,1.21,3.72,3.11c0.07,0.42,0.07,0.86,0.07,1.28 c0,12.49-0.06,24.98,0.02,37.46C30,75,34.09,81.36,41.98,85c12.06,5.55,26.39-2.53,28.05-15.67c0.11-0.91,0.19-1.83,0.19-2.74 c0.01-13.43,0.03-26.87,0-40.3c-0.02-6.14-4.06-11.17-9.98-12.56c-7.8-1.83-15.59,4.17-15.64,12.18 c-0.07,12.34-0.03,24.69-0.01,37.03c0,3.04,2.48,5.47,5.48,5.48c3.02,0.01,5.5-2.44,5.5-5.54c0.02-11.43,0.01-22.86,0.01-34.28 c0-0.51,0.03-1.04,0.16-1.53c0.45-1.69,1.97-2.72,3.76-2.63c1.65,0.09,3.02,1.3,3.32,2.96c0.07,0.36,0.1,0.74,0.1,1.11 c0,11.37,0.02,22.74,0,34.11C62.9,69.29,58.5,74.47,51.96,75.6c-6.93,1.2-13.97-4.17-14.62-11.16c-0.07-0.8-0.12-1.6-0.12-2.4 c-0.01-11.8-0.01-23.6,0-35.4c0.01-6.28,2.27-11.62,7.08-15.67c5.85-4.92,12.58-6.25,19.78-3.69c7.26,2.57,11.63,7.88,13.14,15.45 c0.24,1.23,0.33,2.5,0.33,3.75c0.02,13.29,0.03,26.58,0.01,39.87c-0.02,13.62-9.44,24.89-22.81,27.34 c-0.87,0.16-1.75,0.26-2.62,0.39C50.76,94.07,49.38,94.07,48.01,94.07z")


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}

</script>